export default __webpack_public_path__ + "static/media/bx_bxl-facebook-circle.7e46ffcb.svg";